import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { DhlFormControl } from '../../dhl-form/models/dhl-form-control';

@Component({
    selector: 'app-generic-warning-message',
    templateUrl: './generic-warning-message.component.html',
    styleUrls: ['./generic-warning-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GenericWarningMessageComponent implements OnInit {

  @Input() configData: DhlFormControl;
  constructor() { }

  ngOnInit(): void {
  }

  closeWarningFn(){
    if(this.configData.warningText){
      this.configData.warningText.showText = false
    }
  }
}
